import { render, staticRenderFns } from "./ModalWarningConfirm.vue?vue&type=template&id=456cc4b9&scoped=true&"
import script from "./ModalWarningConfirm.vue?vue&type=script&lang=js&"
export * from "./ModalWarningConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ModalWarningConfirm.vue?vue&type=style&index=0&id=456cc4b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456cc4b9",
  null
  
)

export default component.exports